export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development'
export const IS_TEST = process.env.NODE_ENV === 'test'
export const IS_PRODUCTION_LIKE = process.env.NODE_ENV === 'production'
export const IS_DEV_SERVER = process.env.NEXT_PUBLIC_WASTEPAY_ENV === 'dev_server'
export const IS_PRODUCTION = process.env.NEXT_PUBLIC_WASTEPAY_ENV === 'production'
